import { TableColumnMeta } from "ds/components/Table/types";
import { SearchQueryOrderDirection } from "types/generated";

export const MODULE_VERSION_TEST_CASES_TABLE_STORAGE_KEY = "moduleVersionTestCasesTableStorageKey";
export const MODULE_VERSION_TEST_CASES_TABLE_FILTERS_STORAGE_KEY =
  "moduleVersionTestCasesTableFiltersStorageKey";

export enum MODULE_VERSION_TEST_CASES_COLUMN_ID {
  STATUS = "STATUS",
  NAME = "NAME",
  COMMIT = "COMMIT",
  STARTED_AT = "STARTED_AT",
  DROPDOWN = "DROPDOWN",
}

const MAX_CELL_WIDTH = 600;

export const MODULE_VERSION_TEST_CASES_TABLE_COLUMNS_CONFIG: Record<
  MODULE_VERSION_TEST_CASES_COLUMN_ID,
  TableColumnMeta
> = {
  [MODULE_VERSION_TEST_CASES_COLUMN_ID.STATUS]: {
    id: MODULE_VERSION_TEST_CASES_COLUMN_ID.STATUS,
    title: "Status",
    minWidth: 120,
    defaultWidth: 160,
    maxWidth: MAX_CELL_WIDTH,
    resizable: true,
    allowsSorting: true,
    canHide: true,
    canPin: true,
    canMove: true,
    configurable: true,
  },
  [MODULE_VERSION_TEST_CASES_COLUMN_ID.NAME]: {
    id: MODULE_VERSION_TEST_CASES_COLUMN_ID.NAME,
    title: "Name",
    minWidth: 150,
    defaultWidth: 400,
    maxWidth: MAX_CELL_WIDTH,
    resizable: true,
    allowsSorting: true,
    canHide: false,
    canPin: true,
    canMove: true,
    configurable: true,
  },
  [MODULE_VERSION_TEST_CASES_COLUMN_ID.COMMIT]: {
    id: MODULE_VERSION_TEST_CASES_COLUMN_ID.COMMIT,
    title: "Commit",
    minWidth: 120,
    defaultWidth: 200,
    maxWidth: MAX_CELL_WIDTH,
    resizable: true,
    allowsSorting: false,
    canHide: true,
    canPin: true,
    canMove: true,
    configurable: true,
  },
  [MODULE_VERSION_TEST_CASES_COLUMN_ID.STARTED_AT]: {
    id: MODULE_VERSION_TEST_CASES_COLUMN_ID.STARTED_AT,
    title: "Started at",
    minWidth: 120,
    defaultWidth: 200,
    maxWidth: MAX_CELL_WIDTH,
    resizable: true,
    allowsSorting: true,
    canHide: true,
    canPin: true,
    canMove: true,
    configurable: true,
  },
  [MODULE_VERSION_TEST_CASES_COLUMN_ID.DROPDOWN]: {
    id: MODULE_VERSION_TEST_CASES_COLUMN_ID.DROPDOWN,
    title: "Table configuration",
    noHeader: true,
    maxWidth: 60,
    minWidth: 60,
    defaultWidth: 60,
    allowsSorting: false,
    resizable: false,
    canHide: false,
    canPin: false,
    canMove: false,
    configurable: false,
  },
};

export const SORT_CONFIG: Record<MODULE_VERSION_TEST_CASES_COLUMN_ID, string> = {
  [MODULE_VERSION_TEST_CASES_COLUMN_ID.STATUS]: "state",
  [MODULE_VERSION_TEST_CASES_COLUMN_ID.NAME]: "title",
  [MODULE_VERSION_TEST_CASES_COLUMN_ID.COMMIT]: "commit",
  [MODULE_VERSION_TEST_CASES_COLUMN_ID.STARTED_AT]: "createdAt",
  [MODULE_VERSION_TEST_CASES_COLUMN_ID.DROPDOWN]: "dropdown",
};

/** Matches `useTableSort` / URL: sort key is the encoded column field (`SORT_CONFIG` value), not the column id. */
export const INITIAL_SORT_OPTION = SORT_CONFIG[MODULE_VERSION_TEST_CASES_COLUMN_ID.STARTED_AT];
export const INITIAL_SORT_DIRECTION = SearchQueryOrderDirection.Desc;
